

import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import BootstrapVue from 'bootstrap-vue';

import Vue from 'vue';
import Vuex from 'vuex';
// import store from './store';
import VueRouter from 'vue-router';

import FontAwesome from '@fortawesome/fontawesome-free';


/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

require('./bootstrap');

/* eslint-disable-next-line */
window.Vue = Vue;

window.moment = require('moment');

window.DOMPurify = require('dompurify');

Vue.use(VueRouter);
Vue.use(Vuex);

const router = new VueRouter({
    mode: 'history',
});



/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// jQuery-ui
// import 'jquery-ui-dist/jquery-ui.min.js';

Vue.use(BootstrapVue);
Vue.component('v-select', vSelect);
Vue.component('datepicker', Datepicker);

Vue.component('student-levels', require('./VueComponents/Student/Level/StudentLevelsComponent.vue').default);
Vue.component('load-spinner', require('./VueComponents/LoadingComponent.vue').default);
Vue.component('level-warning', require('./VueComponents/Student/Level/PreviousLevelWarning.vue').default);
Vue.component('student-training-plan', require('./VueComponents/Student/TrainingPlanComponent.vue').default);
Vue.component('final-completion', require('./VueComponents/Student/FinalCompletionComponent.vue').default);

Vue.component('video-component', require('./VueComponents/VideoComponent.vue').default);

Vue.component('induction-form', require('./VueComponents/InductionForm.vue').default);

Vue.component('observation-report', require('./VueComponents/AssessmentTool/ObservationReportComponent.vue').default);
Vue.component('final-record', require('./VueComponents/AssessmentTool/FinalRecordComponent.vue').default);

Vue.component('block-calendar', require('./VueComponents/BlockCalendar.vue').default);

const app = new Vue({
    el: '#app',
    // store,
    router,
});

/* global Noty */
/* global _ */
// window.Noty = require('noty');
//
// Noty.overrideDefaults({
//     layout: 'topRight',
//     theme: 'relax',
//     progressBar: true,
//     closeWith: ['click', 'button'],
//     modal: true,
//     timeout: 2500,
// });

// script.js
Vue.prototype.trans = (string, args) => {
    let value = _.get(window.i18n, string);

    _.eachRight(args, (paramVal, paramKey) => {
        value = _.replace(value, `:${paramKey}`, paramVal);
    });
    return value;
};
